export const prepareRequestUrl = (url: string, baseUrl: string) => {
  if (url.startsWith('http')) {
    return url
  }
  return `${baseUrl.replace(/\/+$/, '')}/${url.replace(/^\/+/, '')}`
}
export function combineClassNames(...args:(string | undefined | null | false)[]):string {
  return args
      .filter(Boolean) // Remove any falsy values (undefined, null, '', false, etc.)
      .join(' '); // Combine all class names with a space
}